import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { CarState } from './types';

type Variables = {
  id: number;
  reservationId: number;
  action: string;
  temperature: number;
};
type Response = CarState;

export const useCarClimateCabin = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async ({ id, reservationId, action, temperature }) =>
    client({
      url: `v2/cars/${id}/climate-cabin`,
      method: 'POST',
      data: {
        reservation_id: reservationId,
        action,
        temperature,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
